module.exports = __webpack_public_path__ + "static/sport/tag-login.45c6c55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/tag-login.png
// module id = Us2E
// module chunks = 0